import { useEffect } from "react"
import { useNavigate } from "react-router"

const useMessagesListener = () => {
  const navigate = useNavigate()

  const messageHandlers = {
    notificationClick: (event) => {
      if (event.data.url) navigate(`/${event.data.url}`)
    },
    newVersion: (event) => {
      navigator.serviceWorker.ready.then(registration => {
        registration.active?.postMessage("skipWaiting")
      }).catch(() => {})
      window.location.reload()
    }
  }

  useEffect(() => {
    const handleMessage = (event) => {
      const messageHandler = messageHandlers[event.data?.type]
      if (messageHandler) messageHandler(event)
    }

    navigator.serviceWorker.addEventListener('message', handleMessage)
    return () => navigator.serviceWorker.removeEventListener('message', handleMessage)
  }, [])
}

export default useMessagesListener
